export const SCROLL_MARGIN = 8;
export const MIN_HEIGHT_LINES = 15;
